__turbopack_context__.v({
  "careersWrapper": "blocks-module-scss-module__mtNyQW__careersWrapper",
  "home": "blocks-module-scss-module__mtNyQW__home",
});
